import { SxProp, useDripsyTheme } from 'dripsy';
import { ViewStyle } from 'react-native';

interface UseProgressBarParams {
  index: number;
  isFirst: boolean;
  isLast: boolean;
}

export const useProgressBar = (params: UseProgressBarParams) => {
  const { isFirst, isLast } = params;
  const { theme } = useDripsyTheme();

  const [inactiveColor, activeColor] = [theme.colors?.$disable as string, theme.colors?.$secondary as string];

  const baseStatusBarStyle: SxProp = {
    flex: 1,
    height: 'auto',
    width: 2
  };
  const noBarStyle = { ...baseStatusBarStyle, backgroundColor: 'transparent' };
  const disabledBarStyle = {
    ...baseStatusBarStyle,
    backgroundColor: inactiveColor
  };

  let barTopStyle = isFirst ? noBarStyle : disabledBarStyle;
  let barBottomStyle = isLast ? noBarStyle : disabledBarStyle;

  const baseAnimatedStatusBarStyle: ViewStyle = {
    position: 'absolute',
    width: 2,
    backgroundColor: activeColor
  };

  const baseAnimatedDotStyle: ViewStyle = {
    borderRadius: 50,
    backgroundColor: activeColor
  };

  const inactiveDotStyle: SxProp = {
    height: '$2',
    width: '$2',
    borderRadius: 50,
    backgroundColor: inactiveColor
  };

  return {
    barTopStyle,
    barBottomStyle,
    baseAnimatedStatusBarStyle,
    baseAnimatedDotStyle,
    inactiveDotStyle,
    colors: {
      activeColor,
      inactiveColor
    }
  };
};
